<script setup lang="ts">
import { cn } from '~~/lib/tw-utils'
import { X } from 'lucide-vue-next'
import { ToastClose, type ToastCloseProps } from 'radix-vue'
import { computed, type HTMLAttributes } from 'vue'

const props = defineProps<ToastCloseProps & {
  class?: HTMLAttributes['class']
}>()

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props

  return delegated
})
</script>

<template>
  <ToastClose v-bind="delegatedProps" :class="cn('absolute right-2 top-2 rounded-md p-1 text-foreground/50 opacity-0 transition-opacity hover_text-foreground focus_opacity-100 focus_outline-none focus_ring-2 group-hover_opacity-100 group-[.destructive]_text-red-300 group-[.destructive]_hover_text-red-50 group-[.destructive]_focus_ring-red-400 group-[.destructive]_focus_ring-offset-red-600', props.class)">
    <X class="h-4 w-4" />
  </ToastClose>
</template>
